import ResourceStore from "../../services/ResourceStore";
import UserStore from "../../../user_dashboard/components/User/UserStore";

class CompanyStore extends ResourceStore {
  async ensureCurrentCompany () {
    if (!this.currentCompany) {
      this.currentCompany = UserStore.state.company || {};
      this.state[this.resourceNameCamelized] = UserStore.state.company || {};
    }

    return this.currentCompany;
  }

  async fetchPublicCountries () {
    const response = await fetch("/api/v4/countries/public");
    const responseJSON = await response.json();

    return responseJSON.countries;
  }

  async fetchAllCurrencies () {
    const response = await fetch("/api/v4/currencies/all");
    const responseJSON = await response.json();

    return responseJSON.currencies;
  }

  updateObject (responseJSON) {
    this.state[this.resourceNameCamelized] = responseJSON[this.resourceName];
    this.currentCompany = this.state[this.resourceNameCamelized];
  }

  refreshCompany (response) {
    this.state[this.resourceNameCamelized] = response.resource;
    this.currentCompany = this.state[this.resourceNameCamelized];
  }

  setCompany (company) {
    this.state[this.resourceNameCamelized] = company;
    this.currentCompany = this.state[this.resourceNameCamelized];
  }

  voucherTemplateCompleted () {
    this.currentCompany.has_voucher_template = true;
    this.state[this.resourceNameCamelized].has_voucher_template = true;
  }

  _baseUrl (params) {
    return "/api/v4";
  }
}

export default new CompanyStore("company");
